import { ROUTES } from "../../constants/routes";
import { Component, inject, signal } from "@angular/core";
import { RouterLink } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { Navbar } from "../../components/navbar/navbar";
import { Breadcrumb } from "../../components/breadcrumb/breadcrumb";
import { Footer } from "../../components/footer/footer";
import { SeoService } from "../../services/seo.service";
import { SITE } from "../../constants/site";
import { breadcrumbSchema } from "../../helpers/structured-data";

@Component({
  selector: "app-feedback",
  imports: [RouterLink, FormsModule, Breadcrumb, Navbar, Footer],
  templateUrl: "./feedback.html",
  styleUrl: "./feedback.scss"
})
export class Feedback {
  readonly routes = ROUTES;
  private readonly seo = inject(SeoService);
  readonly site = SITE;

  readonly submitted = signal(false);
  readonly rating = signal(0);

  model = {
    name: "",
    email: "",
    topic: "",
    message: ""
  };

  readonly topics = [
    "Product experience",
    "Data quality",
    "Pricing",
    "Support",
    "Feature request",
    "Something else"
  ];

  setRating(value: number): void {
    this.rating.set(value);
  }

  submit(): void {
    this.submitted.set(true);
  }

  ngOnInit(): void {
    this.seo.apply({
      title: "Give Feedback | Help Us Improve VerifyDeceased",
      description:
        "Share your feedback on VerifyDeceased. Tell us what is working, what could be better and what you would like to see next. Your input shapes our roadmap.",
      path: "/feedback",
      keywords:
        "VerifyDeceased feedback, product feedback, suggest a feature death verification, contact VerifyDeceased",
      structuredData: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Feedback", path: "/feedback" }
        ])
      ]
    });
  }
}
